/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-27 16:49:55
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-04-27 18:14:51
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/SalesChannelPreviewPageComponents/TipsAndSwitch/index.tsx
 */
import React from 'react';
import css from './css.module.less';

import { Switch } from 'src/components/Antd';

const TipsAndSwitch = (props) => {
  const { enabled, onChange, title, content, disabled } = props;
  return (
    <React.Fragment>
      <div className={css.switchContainer}>
        {title}
        <Switch checked={enabled} onChange={onChange} disabled={disabled} />
      </div>
      {content && <div className={css.enabledTip}>{content}</div>}
    </React.Fragment>
  );
};
export default TipsAndSwitch;
